export default "__VITE_ASSET__48abc1bb__"